import React, { FC } from 'react'
import { Button, Icon, useThemePerClass } from '@afterpaytouch/core'
import { CloseCheckout } from '../CloseCheckout'
import styles from './style.module.css'
import { useRoutePageName } from '../../config/router'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { PageNames } from '../../model'
import { useAppRouter, useIsAfterpayAppGiftCardFlow } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { CHECKOUT_FLOW_TYPE, postCheckoutFlowMessage } from '../../integrations/inappbrowser-messenger'

export const AFFHeader: FC = () => {
  const { t } = useTranslation()
  const themeClass = useThemePerClass(styles)
  const pageName = useRoutePageName()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const isBackButton = [PageNames.ADD_NEW_PAYMENT_METHOD, PageNames.AFF_TRUTH_IN_LENDING, PageNames.PAYMENT_METHOD].includes(pageName)
  const router = useAppRouter()
  const isAfterpayAppGiftCardFlow = useIsAfterpayAppGiftCardFlow()

  const handleBack = (): void => {
    logEvent(`Pressed Back on ${pageName} Page`)
    router.back()
  }

  const handleClose = (): void => {
    logEvent(`Pressed Close on ${pageName} Page`)
    if (isAfterpayAppGiftCardFlow) {
      postCheckoutFlowMessage(CHECKOUT_FLOW_TYPE.ON_GIFT_CARD_CLOSE)
    }
  }

  if (isAfterpayAppGiftCardFlow) {
    return null
  }

  return (
    <div className={themeClass.navigation}>
      {isBackButton ? (
        <Button type='button' size='Regular' aria-label={t('common:back')} kind='Link' testNameSpace='back-checkout' onClick={handleBack}>
          <Icon.ArrowLeft size='Small' color={'Black'} />
        </Button>
      ) : (
        <CloseCheckout aria-label={t('common:closeCheckoutAria')} size='Regular' kind='Link' testNameSpace='close-checkout' onClick={handleClose}>
          <Icon.Close size='Small' color={'Black'} />
        </CloseCheckout>
      )}
    </div>
  )
}
